<div class="main-slider style-two default-banner container" style="padding: 0 !important;">
  <div class="tp-banner-container">
    <div class="tp-banner">
      <div id="rev_slider_1059_1_wrapper" class="rev_slider_wrapper " data-alias="duotone192" data-source="gallery"
        style="background-color:#000000;padding:0px;">
        <!-- START REVOLUTION SLIDER 5.3.0.2 fullscreen mode -->
        <div id="rev_slider_1059_1" class="rev_slider" style="display:none;" data-version="5.3.0.2">
          <ul>
            <!-- SLIDE  -->
            <ng-container *ngFor="let item of banner">
              <li data-transition="parallaxvertical" data-slotamount="default" data-hideafterloop="0"
                data-hideslideonmobile="off" data-easein="default" data-easeout="default" data-masterspeed="default"
                data-thumb="images/main-slider/slide14.jpg" data-rotate="0" data-fstransition="paper cut"
                data-fsmasterspeed="300" data-fsslotamount="7" data-saveperformance="off" data-title="Slide"
                data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7=""
                data-param8="" data-param9="" data-param10="" data-description="">
                <!-- MAIN IMAGE -->
                <img src="{{domain}}{{item.imagen}}" style="background-color: #ffffff;" alt=""
                  data-lazyload="images/main-slider/slide14.jpg" data-bgposition="center center" data-bgfit="contain"
                  data-bgrepeat="no-repeat" data-bgparallax="3" class="rev-slidebg" data-no-retina>
                <!-- LAYERS -->
                <!-- LAYER NR. 1 
              <div class="tp-caption tp-shape tp-shapewrapper "
                   id="slide-100-layer-1"
                   data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']"
                   data-y="['middle','middle','middle','middle']" data-voffset="['0','0','0','0']"
                   data-width="full"
                   data-height="full"
                   data-whitespace="nowrap"
                   data-type="shape"
                   data-basealign="slide"
                   data-responsive_offset="off"
                   data-responsive="off"
                   data-frames='[{"from":"opacity:0;","speed":1000,"to":"o:1;","delay":0,"ease":"Power4.easeOut"},{"delay":"wait","speed":1000,"to":"opacity:0;","ease":"Power4.easeOut"}]'
                   data-textAlign="['left','left','left','left']"
                   data-paddingtop="[0,0,0,0]"
                   data-paddingright="[0,0,0,0]"
                   data-paddingbottom="[0,0,0,0]"
                   data-paddingleft="[0,0,0,0]"
                   style="z-index: 2;border-color:rgba(0, 0, 0, 0);border-width:0px;"> 
                   <img src="{{domain}}{{item.imagen}}" style="width: 100px;height: 100px;"/>
                  </div>-->

                <!-- LAYER NR. 2 -->
                <div class="tp-caption Concept-SubTitle   tp-resizeme rs-parallaxlevel-2" id="slide-2972-layer-4"
                  data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']"
                  data-y="['middle','middle','middle','bottom']" data-voffset="['250','260','200','20']"
                  data-fontsize="['15','15','10','9']" data-lineheight="['25','25','20','20']"
                  data-width="['800','600','500','440']" data-height="none" data-whitespace="normal" data-type="text"
                  data-responsive_offset="on"
                  data-frames='[{"from":"z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;","speed":1500,"to":"o:1;","delay":1500,"ease":"Power3.easeInOut"},{"delay":"wait","speed":1000,"to":"x:left(R);","ease":"Power3.easeIn"}]'
                  data-textAlign="['left','left','left','left']" data-paddingtop="[10,10,10,10]"
                  data-paddingright="[10,10,10,10]" data-paddingbottom="[10,10,10,10]" data-paddingleft="[10,10,10,10]"
                  style="z-index: 6; color:#ffffff;background-color: rgba(0, 0 ,0 ,.5);text-align: center;border-radius: 5px;">
                  <a style="color:white;font-size: 16px;" href="{{item.enlace}}">
                    {{item.titulo}}
                  </a>
                </div>

                <!-- LAYER NR. 4 -->
                <div class="tp-caption tp-shape tp-shapewrapper  tp-resizeme rs-parallaxlevel-2" id="slide-2972-layer-5"
                  data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']"
                  data-y="['middle','middle','middle','middle']" data-voffset="['290','310','43','39']" data-width="80"
                  data-height="2" data-whitespace="nowrap" data-type="shape" data-responsive_offset="on"
                  data-frames='[{"from":"x:[175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;","mask":"x:[-100%];y:0;s:inherit;e:inherit;","speed":1500,"to":"o:1;","delay":1900,"ease":"Power3.easeOut"},{"delay":"wait","speed":1000,"to":"x:left(R);","ease":"Power3.easeIn"}]'
                  data-textAlign="['left','left','left','left']" data-paddingtop="[0,0,0,0]"
                  data-paddingright="[0,0,0,0]" data-paddingbottom="[0,0,0,0]" data-paddingleft="[0,0,0,0]"
                  style="z-index: 8;text-transform:left;background-color:rgba(255, 255, 255, 1.00);border-color:rgba(0, 0, 0, 0.50);border-width:0px;">
                </div>
                <!--
                   <div class="tp-caption "
                   id="slide-2974-layer-7"
                   data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']"
                   data-y="['top','top','top','top']" data-voffset="['730','732','700','480']"
                   data-width="none"
                   data-height="none"
                   data-whitespace="nowrap"

                   data-type="text"
                   data-actions='[{"event":"click","action":"startlayer","layer":"slide-2972-layer-6","delay":""},{"event":"click","action":"startlayer","layer":"slide-2972-layer-8","delay":""},{"event":"click","action":"stoplayer","layer":"slide-2974-layer-7","delay":""},{"event":"click","action":"startlayer","layer":"slide-2972-layer-9","delay":""},{"event":"click","action":"startlayer","layer":"slide-2972-layer-10","delay":""},{"event":"click","action":"startlayer","layer":"slide-2972-layer-11","delay":""},{"event":"click","action":"stoplayer","layer":"slide-2972-layer-12","delay":""}]'
                   data-responsive_offset="on"
                   data-responsive="off"
                   data-frames='[{"from":"z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;","speed":1000,"to":"o:1;","delay":2100,"ease":"Power3.easeInOut"},{"delay":"bytrigger","speed":2,"to":"auto:auto;","ease":"nothing"},{"frame":"hover","speed":"300","ease":"Power1.easeInOut","to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgba(255, 255, 255, 1.00);bg:rgba(255, 255, 255, 0.15);bs:solid;"}]'
                   data-textAlign="['left','left','left','left']"
                   data-paddingtop="[0,0,0,0]"
                   data-paddingright="[0,0,0,0]"
                   data-paddingbottom="[0,0,0,0]"
                   data-paddingleft="[0,0,0,0]"
                   data-lasttriggerstate="reset"
                   style="z-index: 9; white-space: nowrap;text-transform:left;outline:none;box-shadow:none;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;cursor:pointer;">
                <a href="#" class="site-button">ver</a>
              </div>
-->

              </li>
              <!-- SLIDE  -->
            </ng-container>
          </ul>
          <div class="tp-bannertimer tp-bottom" style="visibility: hidden !important;"></div>
        </div>
      </div><!-- END REVOLUTION SLIDER -->
    </div>
  </div>
</div>
<!-- Slider END -->
<!-- Services  -->
<div class="section-full about-block">
  <div class="container">
    <div class="row">

      <div class="icon-bx-wraper center col-md-4 col-sm-4 bg-primary icon-box p-a0">
        <div class="icon-bx-lg text-white"> <a href="http://vpc.planificacion.gob.bo/" class="icon-cell"> <img
              src="/assets/images/books-stack-of-three.svg" alt=""> </a> </div>
        <div class="icon-content text-white p-lr15 p-tb30">
          <p>VICEMINISTERIO DE PLANIFICACIÓN Y <br> COORDINACIÓN</p>

        </div>
      </div>
      <div class="icon-bx-wraper center col-md-4 col-sm-4 bg-primary-dark icon-box p-a0">
        <div class="icon-bx-lg text-white"> <a href="http://www.vipfe.gob.bo/" class="icon-cell"><img
              src="/assets/images/money.svg" alt=""> </a> </div>
        <div class="icon-content text-white p-lr15 p-tb30">
          <p>VICEMINISTERIO DE INVERSIÓN PÚBLICA Y FINANCIAMIENTO EXTERNO</p>
        </div>
      </div>
      <div class="icon-bx-wraper center col-md-4 col-sm-4 bg-primary icon-box p-a0">
        <div class="icon-bx-lg text-white"> <a routerLink="/content/1484" class="icon-cell"><img
              src="/assets/images/construct.svg" alt=""> </a> </div>
        <div class="icon-content text-white p-lr15 p-tb30">
          <p>VICEMINISTERIO DE PLANIFICACIÓN ESTRATÉGICA DEL ESTADO</p>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="section-full about-block">
  <div class="container">
    <div class="row">

      <div class="icon-bx-wraper center col-md-12 col-sm-12 bg-danger icon-box p-a0">
        <a href="" [routerLink]="'/formulario-denuncia'"><img style="width: 100%; height:200px; padding: 3px;"
            src="/assets/denuncias_af.png" class="logo_menu_l animation" alt=""></a>
      </div>


    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/layouts/banner/banner.component.html